import { Modal, type ModalFuncProps } from 'antd';

export function showConfirmModal(props: ModalFuncProps) {
  return Modal.confirm({ ...props, maskClosable: false });
}
